import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import {
	HtmlNewsletterTemplateCardHeight,
	HtmlNewsletterTemplateCardWidth,
} from '../../components/templateCards/HtmlNewsletterTemplateCard/styles';
import { brandPrimaryHover, titles } from '../../styles/colors';
import { Layouts } from '../../styles/styles';

const infoGraphicSize = 60;

const {
	colors,
	spacing: { sm, md, lg, xl },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {},
	createTemplateCard: {
		background: '#E8F3F9',
		border: `1px dashed ${brandPrimaryHover}`,
		color: '#3F3F3F',
		...Layouts.verticalStack(12),
	},
	header: {
		color: titles,
		fontSize: 18,
		marginBottom: sm + 4, // 12px - reduced from lg (24px)
	},
	infoHeader: {
		background: colors.tertiary.light,
		borderLeft: `3px solid ${colors.hover.main}`,
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		fontSize: 14,
		marginBottom: lg,
		padding: `${md}px ${md}px ${md}px ${xl}px`,
	},
	infoHeaderContent: {
		width: `calc(100% - ${infoGraphicSize + 20}px)`,
	},
	infoHeaderContentBold: {
		fontSize: 18,
		paddingBottom: sm,
	},
	infoHeaderGraphic: {
		height: infoGraphicSize,
		marginRight: 20,
		width: infoGraphicSize,
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		height: HtmlNewsletterTemplateCardHeight,
		justifyContent: 'center',
		width: HtmlNewsletterTemplateCardWidth,
	},
	templates: {
		display: 'grid',
		gridGap: sm,
		gridTemplateColumns: `repeat(auto-fill, minmax(${HtmlNewsletterTemplateCardWidth}px,1fr))`,
		gridAutoRows: 'auto',
	},
	templatesContainer: {
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
});
